/* eslint-disable no-case-declarations */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable react/react-in-jsx-scope */
import {
  Award,
  Briefcase,
  BriefcaseClock,
  BriefcaseSync,
  Building,
  BuildingIndustries,
  Calendar,
  Cash,
  ChartLine,
  GraduationHat,
  Limit,
  LinkedinSquare,
  MapPin,
  Rocket,
  Search,
  Sitemap,
  Tool,
  User,
  UserGroup,
  Users,
  UserTie,
  Wallet,
  World,
} from '@saleshandy/icons';
import { useHistory, useLocation } from 'react-router-dom';
import { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../store/root-reducer';
import {
  clearBulkPeopleSearch,
  setBulkPeopleModeActive,
} from '../../v2-lead-slice';
import {
  FilterComponentType,
  LeadFinderSecondaryTab,
  LeadFinderPrimaryTab,
} from '../../types';
import {
  DEGREE_DATA,
  DEPARTMENT_DATA,
  INDUSTRY_DATA,
  LOCATION_DATA,
  CHANGE_JOB_DATA,
  EMPLOYEE_COUNT_DATA,
  MANAGEMENT_LEVELS_DATA,
  REVENUE_DATA,
  YEARS_OF_EXPERIENCE_DATA,
  YEARS_OF_EXPERIENCE_DATA_V2,
  PROJECTED_BASE_SALARY_DATA,
  LINKEDIN_CONNECTION_COUNT_DATA,
  LATEST_FUNDING_DATE_RANGE_DATA,
} from '../../helpers/filter-data';
import { getFilterValues } from '../../helpers/helper';
import { getCompanyNameByIdsAPI } from '../../helpers/leads.api';
import { addCompanyMappings } from '../../utils/company-id-name-map';

type CompanyListOption = { id: number; label: string; count?: number };

export const FILTER_LIST: any = [
  {
    id: 'filter-people-list',
    key: 'people_list',
    label: 'People List',
    group: 'List Inclusion / Exclusion',
    icon: <User />,
    type: [
      {
        id: 'filter-people-list-checkbox',
        key: 'people_list',
        excludeKey: 'excludePeople_list',
        value: FilterComponentType.COMPANY_LIST,
        inputPlaceHolder: 'Search and Select',
        includeMaxLimit: 50,
        maxTotalLimit: 50,
        expandedMaxFilterTags: 5,
      },
    ],
  },
  {
    id: 'filter-company-list',
    key: 'company_list',
    label: 'Company List',
    group: 'List Inclusion / Exclusion',
    icon: <Building />,
    type: [
      {
        id: 'filter-company-list-checkbox',
        key: 'company_list',
        excludeKey: 'excludeCompany_list',
        value: FilterComponentType.COMPANY_LIST,
        inputPlaceHolder: 'Search and Select',
        includeMaxLimit: 50,
        maxTotalLimit: 50,
        expandedMaxFilterTags: 5,
      },
    ],
  },
  {
    id: 'filter-name',
    key: 'full_name',
    label: 'Name',
    group: 'Personal',
    icon: <User />,
    type: [
      {
        id: 'filter-name-search-input',
        key: 'full_name',
        value: FilterComponentType.SEARCH_INPUT,
        placeholder: 'name',
        advanceFilters: {
          showExactMatchCheckbox: true,
        },
      },
    ],
  },
  {
    id: 'filter-location',
    key: 'location',
    label: 'Location',
    group: 'Personal',
    icon: <MapPin />,
    type: [
      {
        id: 'filter-location-checkboxes',
        key: 'location',
        value: FilterComponentType.MULTILEVEL_CHECKBOX,
        inputClassName: 'location-input mb-0',
        inputPlaceHolder: 'Enter location',
        list: LOCATION_DATA,
        advanceFilters: {
          showExactMatchCheckbox: true,
        },
      },
    ],
  },
  {
    id: 'filter-linkedin-url',
    key: 'linkedin_url',
    label: 'LinkedIn URL',
    group: 'Personal',
    icon: <LinkedinSquare />,
    type: [
      {
        id: 'filter-linkedin-url-search-input',
        key: 'linkedin_url',
        value: FilterComponentType.MULTILEVEL_CHECKBOX,
        inputPlaceHolder: 'Enter LinkedIn URL',
        includeMaxLimit: 100,
        expandedMaxFilterTags: 5,
        enableBulkSearch: true,
        hideIncludeExclude: true,
      },
    ],
  },
  // {
  //   id: 'filter-linkedin-connection-count',
  //   key: 'linkedin_connection_count',
  //   label: 'LinkedIn Connections',
  //   group: 'Personal',
  //   icon: <Connections />,
  //   type: [
  //     {
  //       id: 'filter-linkedin-connection-count-dropdown-1',
  //       key: 'linkedin_connection_count',
  //       value: FilterComponentType.DROP_DOWN,
  //       placeholder: 'Select connection count',
  //       list: LINKEDIN_CONNECTION_COUNT_DATA,
  //     },
  //   ],
  // },
  {
    id: 'filter-linkedin-followers-count',
    key: 'linkedin_followers_count',
    label: 'LinkedIn Followers',
    group: 'Personal',
    icon: <Users />,
    type: [
      {
        id: 'filter-linkedin-followers-count-dropdown-1',
        key: 'linkedin_followers_count',
        value: FilterComponentType.DROP_DOWN,
        placeholder: 'Select followers count',
        list: LINKEDIN_CONNECTION_COUNT_DATA,
      },
    ],
  },
  {
    id: 'filter-company-name',
    key: 'company_ids',
    group: 'Company',
    label: 'Company Name',
    icon: <Building />,
    type: [
      {
        id: 'filter-company-name-search-checkbox',
        key: 'company_ids',
        value: FilterComponentType.MULTILEVEL_CHECKBOX,
        inputPlaceHolder: 'Enter Company Name',
        inputClassName: 'employer-input',
        includeMaxLimit: 100,
        expandedMaxFilterTags: 5,
        enableBulkSearch: true,
        bulkSearchKey: 'company_name',
        // disableCustomInput: true,
        advanceFilters: {
          showIncludePastJobsCheckbox: true,
        },
      },
    ],
  },
  {
    id: 'filter-company-domain',
    key: 'company_domain',
    label: 'Company Domain',
    group: 'Company',
    icon: <World />,
    type: [
      {
        id: 'filter-company-domain-search-checkbox',
        key: 'company_domain',
        value: FilterComponentType.MULTILEVEL_CHECKBOX,
        inputPlaceHolder: 'Enter Company Domain',
        includeMaxLimit: 100,
        enableBulkSearch: true,
        bulkSearchKey: 'company_domain',
        // disableCustomInput: true,
        // hideIncludeExclude: true,
      },
    ],
  },
  {
    id: 'filter-industry',
    key: 'company_industry',
    label: 'Industry',
    group: 'Company',
    icon: <BuildingIndustries />,
    type: [
      {
        id: 'filter-industry-checkbox',
        key: 'company_industry',
        value: FilterComponentType.MULTILEVEL_CHECKBOX,
        inputClassName: 'industry-search-input mb-0',
        inputPlaceHolder: 'Enter industry',
        list: INDUSTRY_DATA,
        includeMaxLimit: 100,
        expandedMaxFilterTags: 5,
        disableCustomInput: true,
      },
    ],
  },
  {
    id: 'filter-is-b2b',
    key: 'is_b2b',
    label: 'Company is B2B',
    group: 'Company',
    icon: <Building />,
    type: [
      {
        id: 'filter-is-b2b-radio-button',
        key: 'is_b2b',
        value: FilterComponentType.RADIO_BUTTON,
        className: 'is-b2b-radio-button',
        hideLabel: true,
      },
    ],
  },
  {
    id: 'filter-company-location',
    key: 'company_hq_location',
    label: 'Company HQ Location',
    group: 'Company',
    icon: <MapPin />,
    type: [
      {
        id: 'filter-location-checkboxes',
        key: 'company_hq_location',
        excludeKey: 'excludeCompany_hq_location',
        value: FilterComponentType.MULTILEVEL_CHECKBOX,
        inputClassName: 'location-input mb-0',
        inputPlaceHolder: 'Enter location',
        list: LOCATION_DATA,
        advanceFilters: {
          showExactMatchCheckbox: true,
        },
      },
    ],
  },
  {
    id: 'filter-company-size',
    key: 'company_size',
    label: 'Employee Count',
    group: 'Company',
    icon: <Users />,
    type: [
      {
        id: 'filter-company-size-dropdown-1',
        key: 'company_size',
        value: FilterComponentType.DROP_DOWN,
        list: EMPLOYEE_COUNT_DATA,
        advanceFilters: {
          showKnownUnknownRadio: true,
        },
      },
    ],
  },
  {
    id: 'filter-company-founded-year',
    key: 'company_founded_year',
    label: 'Founding Year',
    group: 'Company',
    icon: <Calendar />,
    type: [
      {
        id: 'filter-company-founded-year-dropdown-1',
        key: 'company_founded_year',
        value: FilterComponentType.DROP_DOWN,
        placeholder: 'Select year',
        list: YEARS_OF_EXPERIENCE_DATA,
        advanceFilters: {
          showKnownUnknownRadio: true,
        },
      },
    ],
  },
  {
    id: 'filter-job-title',
    key: 'job_title',
    label: 'Job Title',
    group: 'Current Role',
    icon: <Briefcase />,
    type: [
      {
        id: 'filter-rol-and-department-search-input-1',
        key: 'job_title',
        value: FilterComponentType.MULTILEVEL_CHECKBOX,
        inputClassName: 'job-title-input',
        inputPlaceHolder: 'Enter job title',
        includeMaxLimit: 100,
        expandedMaxFilterTags: 5,
        advanceFilters: {
          showExactMatchCheckbox: true,
          showKnownUnknownRadio: true,
          showIncludePastJobsCheckbox: true,
        },
      },
    ],
  },
  {
    id: 'filter-department',
    key: 'department',
    label: 'Department',
    group: 'Current Role',
    icon: <UserGroup />,
    type: [
      {
        id: 'filter-rol-and-department-checkbox-1',
        key: 'department',
        value: FilterComponentType.MULTILEVEL_CHECKBOX,
        hideSearchBox: true,
        removeTopMargin: true,
        list: DEPARTMENT_DATA,
        advanceFilters: {
          showIncludePastJobsCheckbox: true,
        },
      },
    ],
  },
  {
    id: 'filter-management-level',
    key: 'management_level',
    label: 'Management Level',
    group: 'Current Role',
    icon: <Sitemap />,
    type: [
      {
        id: 'filter-rol-and-department-search-checkbox-1',
        key: 'management_level',
        value: FilterComponentType.MULTILEVEL_CHECKBOX,
        removeTopMargin: true,
        hideSearchBox: true,
        list: MANAGEMENT_LEVELS_DATA,
      },
    ],
  },
  {
    id: 'filter-decision-maker',
    key: 'decision_maker',
    label: 'Decision Maker',
    group: 'Current Role',
    icon: <UserTie />,
    type: [
      {
        id: 'filter-decision-maker-radio-button',
        key: 'decision_maker',
        value: FilterComponentType.RADIO_BUTTON,
        hideLabel: true,
      },
    ],
  },
  {
    id: 'filter-projected-base-salary',
    key: 'projected_base_salary',
    label: 'Projected Base Salary in Dollars',
    group: 'Current Role',
    icon: <Wallet />,
    type: [
      {
        id: 'filter-projected-base-salary-dropdown-1',
        key: 'projected_base_salary',
        value: FilterComponentType.DROP_DOWN,
        placeholder: 'Select salary',
        list: PROJECTED_BASE_SALARY_DATA,
        isPrefix: true,
        advanceFilters: {
          showKnownUnknownRadio: true,
        },
      },
    ],
  },
  {
    id: 'filter-total-experience',
    key: 'total_experience',
    label: 'Years of Experience',
    group: 'Experience',
    icon: <Calendar />,
    type: [
      {
        id: 'filter-total-experience-dropdown-1',
        key: 'total_experience',
        value: FilterComponentType.DROP_DOWN,
        placeholder: 'Select experience',
        list: YEARS_OF_EXPERIENCE_DATA_V2,
        advanceFilters: {
          showKnownUnknownRadio: true,
        },
      },
    ],
  },
  {
    id: 'filter-years-experience',
    key: 'current_company_experience',
    label: 'Current Company Experience',
    group: 'Experience',
    icon: <Calendar />,
    type: [
      {
        id: 'filter-years-experience-dropdown-1',
        key: 'current_company_experience',
        value: FilterComponentType.DROP_DOWN,
        placeholder: 'Select experience',
        list: YEARS_OF_EXPERIENCE_DATA_V2,
      },
    ],
  },
  {
    id: 'filter-current-role-tenure',
    key: 'current_role_tenure',
    label: 'Tenure in Current Role',
    group: 'Experience',
    icon: <BriefcaseClock />,
    type: [
      {
        id: 'filter-current-role-tenure-dropdown-1',
        key: 'current_role_tenure',
        value: FilterComponentType.DROP_DOWN,
        placeholder: 'Select tenure',
        list: YEARS_OF_EXPERIENCE_DATA_V2,
      },
    ],
  },
  {
    id: 'filter-jobs-changed-within',
    key: 'jobs_changed_within',
    label: 'Changed Jobs Within',
    group: 'Experience',
    icon: <BriefcaseSync />,
    type: [
      {
        id: 'filter-jobs-changed-within-dropdown-1',
        key: 'jobs_changed_within',
        value: FilterComponentType.DROP_DOWN,
        placeholder: 'Select Job Change',
        list: CHANGE_JOB_DATA,
        advanceFilters: {
          showKnownUnknownRadio: true,
        },
      },
    ],
  },
  {
    id: 'filter-education',
    key: 'education',
    label: 'Education',
    group: 'Skills and Qualification',
    icon: <GraduationHat />,
    type: [
      {
        id: 'filter-education-search-checkbox-3',
        key: 'education_degrees',
        value: FilterComponentType.MULTILEVEL_CHECKBOX,
        inputPlaceHolder: 'Enter Degree or Institution Name',
        list: DEGREE_DATA,
      },
    ],
  },
  {
    id: 'filter-skills',
    key: 'skills',
    label: 'Skills',
    group: 'Skills and Qualification',
    icon: <Tool />,
    type: [
      {
        id: 'filter-skills-search-checkbox-1',
        key: 'skills',
        value: FilterComponentType.MULTILEVEL_CHECKBOX,
        inputClassName: 'skills-input',
        inputPlaceHolder: 'Enter skill',
        includeMaxLimit: 100,
        expandedMaxFilterTags: 5,
        advanceFilters: {
          showExactMatchCheckbox: true,
        },
      },
    ],
  },
  {
    id: 'filter-certification',
    key: 'certifications',
    label: 'Certification',
    group: 'Skills and Qualification',
    icon: <Award />,
    type: [
      {
        id: 'filter-certification-search-input-1',
        key: 'certifications',
        value: FilterComponentType.MULTILEVEL_CHECKBOX,
        inputPlaceHolder: 'certifications',
        inputClassName: 'certification-input',
        includeMaxLimit: 100,
        hideIncludeExclude: true,
      },
    ],
  },
  {
    id: 'filter-revenue',
    key: 'company_annual_revenue',
    label: 'Company Revenue',
    group: 'Revenue',
    icon: <ChartLine />,
    type: [
      {
        id: 'filter-company-revenue-drop-down',
        key: 'company_annual_revenue',
        value: FilterComponentType.DROP_DOWN,
        list: REVENUE_DATA,
        isPrefix: true,
        advanceFilters: {
          showKnownUnknownRadio: true,
        },
      },
    ],
  },
  {
    id: 'filter-funding-amount',
    key: 'company_funding_amount',
    label: 'Funding Amount',
    group: 'Revenue',
    icon: <Cash />,
    type: [
      {
        id: 'filter-funding-amount-drop-down',
        key: 'company_funding_amount',
        value: FilterComponentType.DROP_DOWN,
        list: REVENUE_DATA,
        isPrefix: true,
        advanceFilters: {
          showKnownUnknownRadio: true,
        },
      },
    ],
  },
  {
    id: 'filter-latest-funding-date',
    key: 'company_funding_date',
    label: 'Latest Funding Date Range',
    group: 'Revenue',
    icon: <Calendar />,
    type: [
      {
        id: 'filter-latest-funding-date-dropdown-1',
        key: 'company_funding_date',
        value: FilterComponentType.DROP_DOWN,
        placeholder: 'Select date',
        list: LATEST_FUNDING_DATE_RANGE_DATA,
        advanceFilters: {
          showKnownUnknownRadio: true,
        },
      },
    ],
  },
  {
    id: 'filter-company-bootstraped',
    key: 'company_bootstraped',
    label: 'Company Bootstraped',
    group: 'Revenue',
    icon: <Rocket />,
    type: [
      {
        id: 'filter-company-bootstraped-dropdown-1',
        key: 'company_bootstraped',
        value: FilterComponentType.RADIO_BUTTON,
        hideLabel: true,
      },
    ],
  },
  {
    id: 'filter-limit',
    key: 'limit',
    label: 'Limit Results Per Company',
    group: 'Other',
    icon: <Limit />,
    type: [
      {
        id: 'filter-limit-search-input',
        key: 'limit',
        value: FilterComponentType.SEARCH_INPUT,
        placeholder: 'limit',
      },
    ],
  },
  {
    id: 'filter-keywords',
    key: 'keywords',
    label: 'Keywords',
    group: 'Other',
    icon: <Search />,
    type: [
      {
        id: 'filter-keywords-search-input-1',
        key: 'keywords',
        value: FilterComponentType.MULTILEVEL_CHECKBOX,
        inputPlaceHolder: 'keywords',
        inputClassName: 'keyword-input',
        includeMaxLimit: 100,
        expandedMaxFilterTags: 5,
        enableBulkSearch: true,
        hideIncludeExclude: true,
      },
    ],
  },
];

export const FILTER_GROUP_ORDER = [
  'List Inclusion / Exclusion',
  'Personal',
  'Company',
  'Current Role',
  'Experience',
  'Skills and Qualification',
  'Revenue',
  'Other',
];

export const useLeadFilter = (
  activeSubTab: LeadFinderSecondaryTab,
  searchLeads: (payload?: any, performSearch?: boolean) => void,
  peopleListsData?: CompanyListOption[],
  companyListsData?: CompanyListOption[],
  activeLeadType?: LeadFinderPrimaryTab,
  userEmail?: string,
  triggerSearchWithFilters?: (filters: URLSearchParams) => void,
  options?: {
    syncTabSpecificPeopleFiltersRef?: (filters: URLSearchParams) => void;
  },
) => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const bulkPeopleSearch = useSelector(
    (state: RootState) => state.leadFinderV2.bulkPeopleSearch,
  );
  const queryParams = new URLSearchParams(location?.search);

  // Track pending filters that haven't been applied yet
  const [pendingFilters, setPendingFilters] = useState<URLSearchParams>(
    new URLSearchParams(location?.search),
  );

  // Ref to track if URL change came from search button click
  const isSearchButtonClickRef = useRef(false);

  const lastAppliedFiltersRef = useRef<string>('');
  const prevActiveLeadTypeRef = useRef<LeadFinderPrimaryTab | undefined>(
    activeLeadType,
  );

  const [skipUrlPushForBulkSearch, setSkipUrlPushForBulkSearch] = useState(
    false,
  );

  const syncPeopleFiltersTabRef = (params: URLSearchParams) => {
    options?.syncTabSpecificPeopleFiltersRef?.(
      new URLSearchParams(params.toString()),
    );
  };

  // State to store company ID to name mapping (for company_ids filter)
  const [companyIdNameMap, setCompanyIdNameMap] = useState<
    Record<string, string>
  >({});

  // Track which company IDs are currently being fetched (for loading skeletons)
  const [loadingCompanyIds, setLoadingCompanyIds] = useState<Set<string>>(
    new Set(),
  );

  // Sync pendingFilters with URL when URL changes externally (initial load, tab switch, etc.)
  useEffect(() => {
    const urlIsEmpty = !(location?.search || '').trim();
    if (urlIsEmpty) {
      setPendingFilters(new URLSearchParams());
      isSearchButtonClickRef.current = false;
      return;
    }
    // Only sync if URL change didn't come from search button click
    if (!isSearchButtonClickRef.current) {
      setPendingFilters(new URLSearchParams(location?.search));
    }
    // Reset the flag after checking
    isSearchButtonClickRef.current = false;
  }, [location?.search]);

  useEffect(() => {
    const urlHasFilters = (location?.search || '').trim().length > 0;
    if (!urlHasFilters) return;
    if (!skipUrlPushForBulkSearch) return;
    setSkipUrlPushForBulkSearch(false);
    lastAppliedFiltersRef.current = '';
  }, [location?.search, skipUrlPushForBulkSearch]);

  // When subtab changes (Total ↔ New) and we're in bulk-search mode, clear filters so UI chips disappear (URL has no params to sync from)
  const prevActiveSubTabRef = useRef(activeSubTab);
  useEffect(() => {
    if (
      prevActiveSubTabRef.current !== activeSubTab &&
      skipUrlPushForBulkSearch
    ) {
      setPendingFilters(new URLSearchParams());
      setSkipUrlPushForBulkSearch(false);
    }
    prevActiveSubTabRef.current = activeSubTab;
  }, [activeSubTab, skipUrlPushForBulkSearch]);

  // Fetch company names by IDs for company_ids filter (for display in collapsed tags)
  useEffect(() => {
    // Only fetch if People tab is active
    if (activeLeadType && activeLeadType !== LeadFinderPrimaryTab.PEOPLE) {
      return;
    }

    const fetchCompanyNames = async () => {
      const includedIds = pendingFilters
        .getAll('company_ids')
        .map((id) => id.replace(/"/g, ''));
      const excludedIds = pendingFilters
        .getAll('excludeCompany_ids')
        .map((id) => id.replace(/"/g, ''));
      const allIds = [...includedIds, ...excludedIds];

      if (allIds.length === 0) return;

      const companyNameQuery = pendingFilters.get('company_name');
      if (
        companyNameQuery != null &&
        String(companyNameQuery).trim().length < 3
      ) {
        return;
      }

      // Find numeric IDs that are not yet in the map (skip custom text entries)
      // eslint-disable-next-line no-restricted-globals
      const idsToFetch = allIds.filter(
        (id) => !isNaN(Number(id)) && !companyIdNameMap[id],
      );

      if (idsToFetch.length === 0) return;

      setLoadingCompanyIds((prev) => {
        const next = new Set(prev);
        idsToFetch.forEach((id) => next.add(id));
        return next;
      });

      try {
        const res = await getCompanyNameByIdsAPI({
          companyIds: idsToFetch.map(Number),
        });

        if (res?.payload && Array.isArray(res.payload)) {
          const newMap: Record<string, string> = {};
          res.payload.forEach((company: any) => {
            const id =
              company?.companyId ??
              company?.company_id ??
              company?.id ??
              company?.companyID;
            const name =
              company?.companyName ??
              company?.company_name ??
              company?.name ??
              company?.companyNAME;

            if (id != null && typeof name === 'string' && name.trim() !== '') {
              newMap[String(id)] = name;
            }
          });

          // Add fallback for IDs we requested but API didn't return (avoids infinite re-fetch loop)
          idsToFetch.forEach((id) => {
            if (!newMap[id]) {
              newMap[id] = `Company #${id}`;
            }
          });

          setCompanyIdNameMap((prev) => ({ ...prev, ...newMap }));
        }
      } catch (error) {
        // Silently fail - tags will show IDs as fallback
        // eslint-disable-next-line no-console
        console.error('Failed to fetch company names:', error);
      } finally {
        setLoadingCompanyIds((prev) => {
          const next = new Set(prev);
          idsToFetch.forEach((id) => next.delete(id));
          return next;
        });
      }
    };

    fetchCompanyNames();
  }, [pendingFilters, activeLeadType, companyIdNameMap]);

  // Persist companyIdNameMap to storage for recent search display
  useEffect(() => {
    if (!userEmail || Object.keys(companyIdNameMap).length === 0) return;
    addCompanyMappings(userEmail, companyIdNameMap);
  }, [userEmail, companyIdNameMap]);

  const __handleSetUniqueKeys = ({
    filterKey,
    uniqueKeys,
    paramsToRead = pendingFilters,
  }: {
    filterKey: string;
    uniqueKeys: any;
    paramsToRead?: URLSearchParams;
  }) => {
    // Skip flag parameters - they shouldn't show as filter tags
    if (
      filterKey.endsWith('_exactMatch') ||
      filterKey.endsWith('_isUnknown') ||
      filterKey.endsWith('_shouldSearchPast')
    ) {
      return;
    }

    // Determine if this is an exclude key
    const isExclude = filterKey.toLowerCase().startsWith('exclude');

    paramsToRead
      .getAll(filterKey)
      ?.map((item) => item.replace(/"/g, ''))
      ?.forEach((param) => {
        switch (filterKey) {
          case 'location':
          case 'excludeLocation':
          case 'company_hq_location':
          case 'excludeCompany_hq_location':
          case 'excludelocation':
            const locationValues = getFilterValues([param], LOCATION_DATA);
            uniqueKeys.add({
              key: filterKey,
              label: locationValues?.length > 0 ? locationValues[0] : param,
              value: param,
              isExclude,
            });
            break;
          case 'department':
          case 'excludeDepartment':
          case 'excludedepartment':
            const departMentValues = getFilterValues([param], DEPARTMENT_DATA);
            uniqueKeys.add({
              key: filterKey,
              label: departMentValues?.length > 0 ? departMentValues[0] : param,
              value: param,
              isExclude,
            });
            break;
          case 'people_list':
          case 'excludePeople_list':
            {
              const listId = parseInt(param, 10);
              const peopleListFromApi = peopleListsData?.find(
                (list) => list.id === listId,
              );
              if (peopleListFromApi) {
                const label =
                  `${peopleListFromApi?.label} (${peopleListFromApi?.count})` ||
                  param;
                uniqueKeys.add({
                  key: filterKey,
                  label,
                  value: param,
                  isExclude,
                });
              } else {
                uniqueKeys.add({
                  key: filterKey,
                  label: param,
                  value: param,
                  isExclude,
                  isLoading: true,
                });
              }
            }
            break;
          case 'company_list':
          case 'excludeCompany_list':
            {
              const listId = parseInt(param, 10);
              const companyListFromApi = companyListsData?.find(
                (list) => list.id === listId,
              );
              if (companyListFromApi) {
                const label =
                  `${companyListFromApi?.label} (${companyListFromApi?.count})` ||
                  param;
                uniqueKeys.add({
                  key: filterKey,
                  label,
                  value: param,
                  isExclude,
                });
              } else {
                uniqueKeys.add({
                  key: filterKey,
                  label: param,
                  value: param,
                  isExclude,
                  isLoading: true,
                });
              }
            }
            break;
          case 'company_industry':
          case 'excludeCompany_industry':
            const industryValues = getFilterValues([param], INDUSTRY_DATA);
            uniqueKeys.add({
              key: filterKey,
              label: industryValues?.length > 0 ? industryValues[0] : param,
              value: param,
              isExclude,
            });
            break;
          case 'company_annual_revenue':
          case 'excludeCompany_annual_revenue':
          case 'company_funding_amount':
            // Format custom values with commas and dollar sign
            const fundingValues = getFilterValues([param], REVENUE_DATA);
            let fundingDisplayLabel = param;

            // If not found in predefined list, it's a custom value - format it
            if (fundingValues?.length === 0) {
              // Check if it's a range (e.g., "5881-10000")
              if (param.includes('-')) {
                const [min, max] = param.split('-');
                const minNum = parseInt(min, 10);
                const maxNum = parseInt(max, 10);
                if (!Number.isNaN(minNum) && !Number.isNaN(maxNum)) {
                  // Format both min and max with commas
                  const formattedMin = minNum.toLocaleString('en-US');
                  const formattedMax = maxNum.toLocaleString('en-US');
                  fundingDisplayLabel = `$${formattedMin} - $${formattedMax}`;
                }
              } else {
                // Single value (e.g., "5881")
                const numValue = parseInt(param, 10);
                if (!Number.isNaN(numValue)) {
                  fundingDisplayLabel = `$${numValue.toLocaleString('en-US')}`;
                }
              }
            } else {
              // Use the label from the predefined list
              const [firstValue] = fundingValues;
              fundingDisplayLabel = firstValue;
            }

            uniqueKeys.add({
              key: filterKey,
              label: fundingDisplayLabel,
              value: param,
              isExclude,
            });
            break;
          case 'management_level':
          case 'excludeManagement_level':
            const managementLevelsValues = getFilterValues(
              [param],
              MANAGEMENT_LEVELS_DATA,
            );
            uniqueKeys.add({
              key: filterKey,
              label:
                managementLevelsValues?.length > 0
                  ? managementLevelsValues[0]
                  : param,
              value: param,
              isExclude,
            });
            break;
          case 'jobs_changed_within':
            const changeJobValues = getFilterValues([param], CHANGE_JOB_DATA);
            uniqueKeys.add({
              key: filterKey,
              label: changeJobValues?.length > 0 ? changeJobValues[0] : param,
              value: param,
              isExclude,
            });
            break;
          case 'total_experience':
          case 'current_company_experience':
          case 'current_role_tenure':
            const yearsOfExperienceValues = getFilterValues(
              [param],
              YEARS_OF_EXPERIENCE_DATA_V2,
            );
            let experienceDisplayLabel = param;

            // If found in predefined list, use the label and add "Years" suffix if not already present
            if (yearsOfExperienceValues?.length > 0) {
              const [firstValue] = yearsOfExperienceValues;
              experienceDisplayLabel = firstValue;
              // Add "Years" suffix if not already present
              if (!experienceDisplayLabel.toLowerCase().includes('years')) {
                experienceDisplayLabel = `${experienceDisplayLabel} Years`;
              }
            } else {
              // Custom value - format and add "Years" suffix
              experienceDisplayLabel = `${param} Years`;
            }

            uniqueKeys.add({
              key: filterKey,
              label: experienceDisplayLabel,
              value: param,
              isExclude,
            });
            break;
          case 'company_size':
            const employeeCountValues = getFilterValues(
              [param],
              EMPLOYEE_COUNT_DATA,
            );
            uniqueKeys.add({
              key: filterKey,
              label:
                employeeCountValues?.length > 0
                  ? employeeCountValues[0]
                  : param,
              value: param,
              isExclude,
            });
            break;
          case 'projected_base_salary':
            const salaryValues = getFilterValues(
              [param],
              PROJECTED_BASE_SALARY_DATA,
            );
            let salaryDisplayLabel = param;

            // If not found in predefined list, it's a custom value - format it
            if (salaryValues?.length === 0) {
              // Check if it's a range (e.g., "50000-100000")
              if (param.includes('-')) {
                const [min, max] = param.split('-');
                const minNum = parseInt(min, 10);
                const maxNum = parseInt(max, 10);
                if (!Number.isNaN(minNum) && !Number.isNaN(maxNum)) {
                  // Format both min and max with commas and dollar sign
                  const formattedMin = minNum.toLocaleString('en-US');
                  const formattedMax = maxNum.toLocaleString('en-US');
                  salaryDisplayLabel = `$${formattedMin} - $${formattedMax}`;
                }
              } else if (param.startsWith('<')) {
                // Handle less than format (e.g., "<50000")
                const numValue = parseInt(param.replace('<', ''), 10);
                if (!Number.isNaN(numValue)) {
                  salaryDisplayLabel = `< $${numValue.toLocaleString('en-US')}`;
                }
              } else if (param.endsWith('+')) {
                // Handle greater than format (e.g., "250000+")
                const numValue = parseInt(param.replace('+', ''), 10);
                if (!Number.isNaN(numValue)) {
                  salaryDisplayLabel = `$${numValue.toLocaleString('en-US')}+`;
                }
              } else {
                // Single value (e.g., "50000")
                const numValue = parseInt(param, 10);
                if (!Number.isNaN(numValue)) {
                  salaryDisplayLabel = `$${numValue.toLocaleString('en-US')}`;
                }
              }
            } else {
              // Use the label from the predefined list (already has dollar sign)
              const [firstValue] = salaryValues;
              salaryDisplayLabel = firstValue;
            }

            uniqueKeys.add({
              key: filterKey,
              label: salaryDisplayLabel,
              value: param,
              isExclude,
            });
            break;
          case 'linkedin_connection_count':
          case 'linkedin_followers_count':
            const connectionValues = getFilterValues(
              [param],
              LINKEDIN_CONNECTION_COUNT_DATA,
            );
            uniqueKeys.add({
              key: filterKey,
              label: connectionValues?.length > 0 ? connectionValues[0] : param,
              value: param,
              isExclude,
            });
            break;
          case 'company_funding_date':
            // Format date as "20 Jan 2025"
            const formatDateReadable = (date: Date) => {
              const months = [
                'Jan',
                'Feb',
                'Mar',
                'Apr',
                'May',
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Dec',
              ];
              const day = date.getDate();
              const month = months[date.getMonth()];
              const year = date.getFullYear();
              return `${day} ${month} ${year}`;
            };

            const fundingDateValues = getFilterValues(
              [param],
              LATEST_FUNDING_DATE_RANGE_DATA,
            );
            let fundingDateDisplayLabel = param;

            // If not found in predefined list, it's a custom value or already formatted
            if (fundingDateValues?.length === 0) {
              // Check if it's a date range (contains " - ")
              if (param.includes(' - ')) {
                const [startDateStr, endDateStr] = param.split(' - ');
                try {
                  const startDate = new Date(decodeURIComponent(startDateStr));
                  const endDate = new Date(decodeURIComponent(endDateStr));
                  if (
                    !Number.isNaN(startDate.getTime()) &&
                    !Number.isNaN(endDate.getTime())
                  ) {
                    // Ensure earlier date comes first in display
                    const minDate = startDate <= endDate ? startDate : endDate;
                    const maxDate = startDate <= endDate ? endDate : startDate;
                    fundingDateDisplayLabel = `${formatDateReadable(
                      minDate,
                    )} - ${formatDateReadable(maxDate)}`;
                  }
                } catch (e) {
                  // If parsing fails, check if already in yyyy-mm-dd format and convert
                  const datePattern = /^\d{4}-\d{2}-\d{2}$/;
                  if (
                    datePattern.test(startDateStr) &&
                    datePattern.test(endDateStr)
                  ) {
                    const startDate = new Date(startDateStr);
                    const endDate = new Date(endDateStr);
                    if (
                      !Number.isNaN(startDate.getTime()) &&
                      !Number.isNaN(endDate.getTime())
                    ) {
                      const minDate =
                        startDate <= endDate ? startDate : endDate;
                      const maxDate =
                        startDate <= endDate ? endDate : startDate;
                      fundingDateDisplayLabel = `${formatDateReadable(
                        minDate,
                      )} - ${formatDateReadable(maxDate)}`;
                    }
                  }
                }
              } else {
                // Single date - check if it's ISO format or yyyy-mm-dd
                try {
                  const date = new Date(decodeURIComponent(param));
                  if (!Number.isNaN(date.getTime())) {
                    fundingDateDisplayLabel = formatDateReadable(date);
                  }
                } catch (e) {
                  // If parsing fails, might already be in correct format
                }
              }
            } else {
              // Use the label from the predefined list
              const [firstValue] = fundingDateValues;
              fundingDateDisplayLabel = firstValue;
            }

            uniqueKeys.add({
              key: filterKey,
              label: fundingDateDisplayLabel,
              value: param,
              isExclude,
            });
            break;
          case 'company_founded_year':
            // Convert relative year keys to actual year range for display
            const currentYear = new Date().getFullYear();
            const trimmedParam = param.trim();
            let displayLabel = param;

            // Handle custom "Before Year" and "After Year" options
            if (trimmedParam.startsWith('-')) {
              const year = parseInt(trimmedParam.slice(1), 10);
              if (!Number.isNaN(year) && year >= 1900 && year <= currentYear) {
                displayLabel = `Before ${year}`;
              }
            } else if (trimmedParam.endsWith('-')) {
              const year = parseInt(trimmedParam.slice(0, -1), 10);
              if (!Number.isNaN(year) && year >= 1900 && year <= currentYear) {
                displayLabel = `After ${year}`;
              }
            } else if (trimmedParam.endsWith('+')) {
              // Handle "20+" format
              const yearsPast = parseInt(trimmedParam.replace('+', ''), 10);
              if (!Number.isNaN(yearsPast)) {
                const minYear = currentYear - yearsPast;
                displayLabel = `${minYear}-${currentYear}`;
              }
            } else if (trimmedParam.includes('-')) {
              // Check if it's already a year range (4-digit years)
              const parts = trimmedParam.split('-');
              if (parts.length === 2) {
                const part1 = parseInt(parts[0].trim(), 10);
                const part2 = parseInt(parts[1].trim(), 10);
                // If both parts are 4-digit years, it's already converted
                if (
                  !Number.isNaN(part1) &&
                  !Number.isNaN(part2) &&
                  part1 >= 1900 &&
                  part1 <= currentYear &&
                  part2 >= 1900 &&
                  part2 <= currentYear
                ) {
                  displayLabel = trimmedParam; // Already a year range
                } else {
                  // Handle "1-3" or "1 -3" format - convert to year range
                  const yearParts = parts.map((p) => parseInt(p.trim(), 10));
                  if (yearParts.length === 2 && !yearParts.some(Number.isNaN)) {
                    const maxYear = currentYear; // First number = current year
                    const minYear = currentYear - yearParts[1]; // Second number = years in past
                    displayLabel = `${minYear}-${maxYear}`;
                  }
                }
              }
            }

            uniqueKeys.add({
              key: filterKey,
              label: displayLabel,
              value: param, // Keep original value for URL
              isExclude,
            });
            break;
          case 'decision_maker':
            if (param === '0') {
              uniqueKeys.add({
                key: filterKey,
                label: 'Is Not Decision Maker',
                value: param,
                isExclude,
              });
            } else {
              uniqueKeys.add({
                key: filterKey,
                label: 'Is Decision Maker',
                value: param,
                isExclude,
              });
            }
            break;
          case 'company_bootstraped':
            if (param === '0') {
              uniqueKeys.add({
                key: filterKey,
                label: 'Is Not Bootstraped',
                value: param,
                isExclude,
              });
            } else {
              uniqueKeys.add({
                key: filterKey,
                label: 'Is Bootstraped',
                value: param,
                isExclude,
              });
            }
            break;
          case 'is_b2b':
            if (param === '0') {
              uniqueKeys.add({
                key: filterKey,
                label: 'Is Not B2B',
                value: param,
                isExclude,
              });
            } else {
              uniqueKeys.add({
                key: filterKey,
                label: 'Is B2B',
                value: param,
                isExclude,
              });
            }
            break;
          case 'limit':
            // Format limit value with commas for display
            // eslint-disable-next-line no-restricted-globals
            const limitNum = parseInt(param, 10);
            if (!Number.isNaN(limitNum)) {
              const formattedLimit = limitNum.toLocaleString('en-US');
              uniqueKeys.add({
                key: filterKey,
                label: formattedLimit,
                value: param,
                isExclude,
              });
            } else {
              uniqueKeys.add({
                key: filterKey,
                label: param,
                value: param,
                isExclude,
              });
            }
            break;
          case 'company_ids':
          case 'excludeCompany_ids': {
            const hasName = !!companyIdNameMap[param];
            const isLoading = loadingCompanyIds.has(param);

            uniqueKeys.add({
              key: filterKey,
              label: hasName ? companyIdNameMap[param] : param,
              value: param,
              isExclude,
              ...(isLoading && { isLoading: true }),
            });
            break;
          }
          default:
            uniqueKeys.add({
              key: filterKey,
              label: param,
              isExclude,
              value: param,
            });
        }
      });
  };

  const handleGetAllKeysByFilterFromQuery = (filter: any) => {
    const uniqueKeys = new Set();

    if (filter.type?.length > 0) {
      // eslint-disable-next-line array-callback-return
      filter.type.map((type) => {
        if (type.key) {
          // Check for isUnknown flag first
          const isUnknownValue = pendingFilters.get(`${type.key}_isUnknown`);

          // If isUnknown is 1, only add the isUnknown tag and skip all other tags
          if (isUnknownValue === '1') {
            uniqueKeys.add({
              key: `${type.key}_isUnknown`,
              label: 'Unknown',
              value: '1',
              isFlag: true,
              flagType: 'isUnknown',
            });
            return; // Skip processing other tags (includes, excludes, flags)
          }

          // For anything else (isUnknown === '0' or not present), process normally
          __handleSetUniqueKeys({ filterKey: type?.key, uniqueKeys });

          // Also check for capitalize exclude keys (e.g., excludeLocation)
          const capitalizeExcludeKey = `exclude${type.key
            .charAt(0)
            .toUpperCase()}${type.key.slice(1)}`;
          __handleSetUniqueKeys({
            filterKey: capitalizeExcludeKey,
            uniqueKeys,
          });

          // Special case: Company Name filter UI uses `company_ids` (autocomplete),
          // but URL/bulk search can also carry `company_name` filters. Show them under the same filter section.
          if (type.key === 'company_ids') {
            __handleSetUniqueKeys({ filterKey: 'company_name', uniqueKeys });
            __handleSetUniqueKeys({
              filterKey: 'excludeCompany_name',
              uniqueKeys,
            });

            const companyNameExactMatchValue = pendingFilters.get(
              'company_name_exactMatch',
            );
            if (companyNameExactMatchValue === '1') {
              uniqueKeys.add({
                key: 'company_name_exactMatch',
                label: 'Exact Match',
                value: '1',
                isFlag: true,
                flagType: 'exactMatch',
              });
            }
          }

          // Add isUnknown tag if value is '0' (Known)
          if (isUnknownValue === '0') {
            uniqueKeys.add({
              key: `${type.key}_isUnknown`,
              label: 'Known',
              value: '0',
              isFlag: true,
              flagType: 'isUnknown',
            });
          }

          // Check for shouldSearchPast flag
          // For company_ids, also check company_name_shouldSearchPast since
          // custom text entries store their flag under that key.
          const shouldSearchPastValue =
            pendingFilters.get(`${type.key}_shouldSearchPast`) ||
            (type.key === 'company_ids'
              ? pendingFilters.get('company_name_shouldSearchPast')
              : null);
          if (shouldSearchPastValue === '1') {
            uniqueKeys.add({
              key: `${type.key}_shouldSearchPast`,
              label: 'Past Companies',
              value: '1',
              isFlag: true,
              flagType: 'shouldSearchPast',
            });
          }

          // Check for exactMatch flag
          const exactMatchValue = pendingFilters.get(`${type.key}_exactMatch`);
          if (exactMatchValue === '1') {
            uniqueKeys.add({
              key: `${type.key}_exactMatch`,
              label: 'Exact Match',
              value: '1',
              isFlag: true,
              flagType: 'exactMatch',
            });
          }
        }
      });
    }
    return uniqueKeys;
  };

  const handleIndividualTag = (tag: any) => {
    // Helper function to remove a specific value from URLSearchParams
    const removeValueFromParams = (
      params: URLSearchParams,
      key: string,
      value: string,
    ) => {
      const normalize = (v: string) => {
        try {
          return decodeURIComponent(String(v)).replace(/"/g, '').trim();
        } catch (_e) {
          return String(v).replace(/"/g, '').trim();
        }
      };
      const target = normalize(value);
      const paramValues = params.getAll(key);
      const updatedValues = paramValues.filter((v) => normalize(v) !== target);
      params.delete(key);
      updatedValues.forEach((v) => params.append(key, v));
      return params;
    };

    const getParamKeyVariants = (key: string): string[] => {
      if (!key) return [];
      const variants = [key, key.toLowerCase()];
      return Array.from(new Set(variants)).filter(Boolean);
    };

    const normalizedTagValue = (tag?.value ?? '').toString().replace(/"/g, '');

    // Always read URL params fresh (avoid stale closure if location.search changed)
    const urlParams = new URLSearchParams(location?.search || '');
    const keysToTry = getParamKeyVariants(tag?.key);
    const normalize = (v: string) => {
      try {
        return decodeURIComponent(String(v)).replace(/"/g, '').trim();
      } catch (_e) {
        return String(v).replace(/"/g, '').trim();
      }
    };
    const existsInUrl = keysToTry.some((k) =>
      urlParams
        .getAll(k)
        .some((v) => normalize(v) === normalize(normalizedTagValue)),
    );

    // Handle flag-type tags (isUnknown, shouldSearchPast, exactMatch)
    if (tag?.isFlag) {
      // Remove from pendingFilters if present
      if (pendingFilters.has(tag?.key)) {
        const newPendingFilters = new URLSearchParams(
          pendingFilters.toString(),
        );
        newPendingFilters.delete(tag?.key);
        setPendingFilters(newPendingFilters);
        syncPeopleFiltersTabRef(newPendingFilters);

        // Bulk search: trigger API with updated filters
        if (skipUrlPushForBulkSearch && triggerSearchWithFilters) {
          const newFiltersStr = newPendingFilters.toString();
          if (newFiltersStr !== lastAppliedFiltersRef.current) {
            lastAppliedFiltersRef.current = newFiltersStr;
            triggerSearchWithFilters(newPendingFilters);
          }
        }
      }

      // Remove from URL if present and trigger search
      if (urlParams.has(tag?.key)) {
        urlParams.delete(tag?.key);
        history.push({
          search: urlParams.toString(),
        });
        syncPeopleFiltersTabRef(new URLSearchParams(urlParams.toString()));
        searchLeads(null, false);
      }
      return;
    }

    // Handle regular filter tags
    // First, always attempt to remove from pendingFilters
    {
      const newPendingFilters = new URLSearchParams(pendingFilters.toString());
      const before = newPendingFilters.toString();
      keysToTry.forEach((k) => {
        removeValueFromParams(newPendingFilters, k, normalizedTagValue);
      });

      // If this was the last value for this key in pendingFilters, also delete associated flags
      if (newPendingFilters.getAll(tag?.key).length === 0) {
        newPendingFilters.delete(`${tag?.key}_exactMatch`);
        newPendingFilters.delete(`${tag?.key}_isUnknown`);
        newPendingFilters.delete(`${tag?.key}_shouldSearchPast`);
      }

      const after = newPendingFilters.toString();
      if (after !== before) {
        setPendingFilters(newPendingFilters);
        syncPeopleFiltersTabRef(newPendingFilters);

        // Bulk search: filters not in URL - trigger API with updated filters after chip removal
        if (skipUrlPushForBulkSearch && triggerSearchWithFilters) {
          if (after !== lastAppliedFiltersRef.current) {
            lastAppliedFiltersRef.current = after;
            triggerSearchWithFilters(newPendingFilters);
          }
        }
      }
    }

    // Then, check if we need to remove from URL (if it was already searched/applied)
    if (!skipUrlPushForBulkSearch) {
      const beforeUrl = urlParams.toString();
      keysToTry.forEach((k) => {
        removeValueFromParams(urlParams, k, normalizedTagValue);
      });

      if (urlParams.getAll(tag?.key).length === 0) {
        urlParams.delete(`${tag?.key}_exactMatch`);
        urlParams.delete(`${tag?.key}_isUnknown`);
        urlParams.delete(`${tag?.key}_shouldSearchPast`);
      }

      if (urlParams.toString() !== beforeUrl || existsInUrl) {
        history.push({ search: urlParams.toString() });
        syncPeopleFiltersTabRef(new URLSearchParams(urlParams.toString()));
        searchLeads(null, false);
      }
    }
  };

  useEffect(() => {
    if (!skipUrlPushForBulkSearch) return;
    if (!triggerSearchWithFilters) return;
    const urlIsEmpty = (location?.search || '').trim().length === 0;
    if (!urlIsEmpty) return;
    const filtersStr = pendingFilters.toString();
    if (filtersStr === lastAppliedFiltersRef.current) return;
    lastAppliedFiltersRef.current = filtersStr;
    triggerSearchWithFilters(new URLSearchParams(filtersStr));
  }, [
    pendingFilters,
    skipUrlPushForBulkSearch,
    triggerSearchWithFilters,
    location?.search,
  ]);

  const handleFoundValueExceptFromList = (key) => {
    let foundedValue = '';
    const paramValues =
      queryParams.getAll(key)?.map((item) => item.replace(/"/g, '')) || [];
    let list = [];
    if (key === 'location') {
      list = LOCATION_DATA;
    } else if (key === 'department') {
      list = DEPARTMENT_DATA;
    } else if (key === 'industry') {
      list = INDUSTRY_DATA;
    }
    if (paramValues?.length > 0) {
      // eslint-disable-next-line array-callback-return
      paramValues.map((value) => {
        const listValues = getFilterValues([value], list);
        if (listValues?.length === 0) {
          foundedValue = value;
        }
      });
    }
    return foundedValue;
  };

  // Helper function to update pending filters based on filter type
  // Returns a new URLSearchParams object instead of mutating the input
  const updatePendingFilters = (
    pendingParams: URLSearchParams,
    filterKey: string,
    filterValue: any,
    filterType: string,
    filterExcludeKey?: string,
    showExactMatch?: boolean,
    showKnownUnknown?: number,
    showIncludePastJobs?: boolean,
  ): URLSearchParams => {
    // Create a copy to avoid mutation
    const newParams = new URLSearchParams(pendingParams.toString());

    // eslint-disable-next-line default-case
    switch (filterType) {
      case FilterComponentType.SEARCH_INPUT:
        newParams.delete(filterKey);
        if (filterValue !== '') {
          newParams.set(filterKey, filterValue.replace(/"/g, ''));
        }
        // Handle exactMatch flag
        if (showExactMatch !== undefined) {
          if (showExactMatch) {
            newParams.set(`${filterKey}_exactMatch`, '1');
          } else {
            newParams.delete(`${filterKey}_exactMatch`);
          }
        }
        break;

      case FilterComponentType.RADIO_BUTTON:
        // Radio buttons: 0 for No, 1 for Yes, not present for not selected
        if (filterValue === 1 || filterValue === 0) {
          newParams.set(filterKey, String(filterValue));
        } else {
          newParams.delete(filterKey);
        }
        break;

      case FilterComponentType.DROP_DOWN:
        if (filterValue !== '') {
          newParams.set(filterKey, filterValue);
        } else {
          const findValue = handleFoundValueExceptFromList(filterKey);
          if (findValue) {
            const paramValues = newParams
              .getAll(filterKey)
              ?.map((item) => item.replace(/"/g, ''));
            const updatedValues = paramValues.filter((v) => v !== findValue);
            newParams.delete(filterKey);
            updatedValues.forEach((v) => newParams.append(filterKey, v));
          } else {
            newParams.delete(filterKey);
          }
        }
        // Handle isUnknown flag for dropdowns
        if (showKnownUnknown !== undefined) {
          if (showKnownUnknown === 1) {
            newParams.set(`${filterKey}_isUnknown`, '1');
          } else if (showKnownUnknown === 0) {
            newParams.set(`${filterKey}_isUnknown`, '0');
          } else {
            newParams.delete(`${filterKey}_isUnknown`);
          }
        }
        break;

      case FilterComponentType.MULTILEVEL_CHECKBOX:
        // Ensure values exist only once (either in includes or excludes) for all filters
        const excludeParamKey =
          filterExcludeKey ||
          `exclude${filterKey.charAt(0).toUpperCase()}${filterKey.slice(1)}`;

        // Clear both includes and excludes
        newParams.delete(filterKey);
        newParams.delete(excludeParamKey);
        if (filterExcludeKey) {
          newParams.delete(filterExcludeKey);
        }

        if (filterKey === 'company_ids') {
          newParams.delete('company_name');
          newParams.delete('excludeCompany_name');
        }

        // Normalize keys by removing quotes for comparison
        const normalizeKey = (key: string) => key.replace(/"/g, '');

        // Step 1: Process includes - remove duplicates
        const uniqueIncludes = new Set<string>();
        const normalizedIncludes: string[] = [];

        if (filterValue?.includedKeys?.length > 0) {
          filterValue.includedKeys.forEach((includeKey: string) => {
            const cleanKey = normalizeKey(includeKey);
            // Skip if already processed (prevent duplicates)
            if (!uniqueIncludes.has(cleanKey)) {
              uniqueIncludes.add(cleanKey);
              normalizedIncludes.push(cleanKey);
            }
          });
        }

        // Step 2: Process excludes - remove duplicates and remove any that are in includes
        const uniqueExcludes = new Set<string>();
        const normalizedExcludes: string[] = [];

        if (filterValue?.excludedKeys?.length > 0) {
          filterValue.excludedKeys.forEach((excludeKey: string) => {
            const cleanKey = normalizeKey(excludeKey);
            // Skip if already processed (prevent duplicates)
            // Also skip if this value is in includes (a value can only be in one list)
            if (
              !uniqueExcludes.has(cleanKey) &&
              !uniqueIncludes.has(cleanKey)
            ) {
              uniqueExcludes.add(cleanKey);
              normalizedExcludes.push(cleanKey);
            }
          });
        }

        // Step 3: Also remove from includes any values that are in excludes
        const finalIncludes = normalizedIncludes.filter(
          (includeKey) => !uniqueExcludes.has(includeKey),
        );

        // Step 4: Add final includes
        finalIncludes.forEach((includeKey) => {
          const targetKey =
            filterKey === 'company_ids' && isNaN(Number(includeKey))
              ? 'company_name'
              : filterKey;
          if (newParams.has(targetKey)) {
            newParams.append(targetKey, includeKey);
          } else {
            newParams.set(targetKey, includeKey);
          }
        });

        // Step 5: Add final excludes
        normalizedExcludes.forEach((excludeKey) => {
          const targetExcludeKey =
            filterKey === 'company_ids' && isNaN(Number(excludeKey))
              ? 'excludeCompany_name'
              : excludeParamKey;
          if (newParams.has(targetExcludeKey)) {
            newParams.append(targetExcludeKey, excludeKey);
          } else {
            newParams.set(targetExcludeKey, excludeKey);
          }
        });

        // Handle exactMatch flag
        if (showExactMatch !== undefined) {
          if (showExactMatch) {
            newParams.set(`${filterKey}_exactMatch`, '1');
          } else {
            newParams.delete(`${filterKey}_exactMatch`);
          }
        }

        // Handle shouldSearchPast flag
        if (showIncludePastJobs !== undefined) {
          const hasCustomNameEntries =
            filterKey === 'company_ids' &&
            (newParams.has('company_name') ||
              newParams.has('excludeCompany_name'));

          if (showIncludePastJobs) {
            if (
              filterKey !== 'company_ids' ||
              newParams.has(filterKey) ||
              !hasCustomNameEntries
            ) {
              newParams.set(`${filterKey}_shouldSearchPast`, '1');
            } else {
              newParams.delete(`${filterKey}_shouldSearchPast`);
            }
            if (hasCustomNameEntries) {
              newParams.set('company_name_shouldSearchPast', '1');
            } else {
              newParams.delete('company_name_shouldSearchPast');
            }
          } else {
            newParams.delete(`${filterKey}_shouldSearchPast`);
            if (filterKey === 'company_ids') {
              newParams.delete('company_name_shouldSearchPast');
            }
          }
        }

        // Handle isUnknown flag
        if (showKnownUnknown !== undefined) {
          if (showKnownUnknown === 1) {
            newParams.set(`${filterKey}_isUnknown`, '1');
          } else if (showKnownUnknown === 0) {
            newParams.set(`${filterKey}_isUnknown`, '0');
          } else {
            newParams.delete(`${filterKey}_isUnknown`);
          }
        }
        break;
    }

    return newParams; // Return the new object
  };

  const handleQuery = ({
    filterKey,
    filterValue,
    filterType,
    filterExcludeKey,
    showExactMatch,
    showKnownUnknown,
    showIncludePastJobs,
    isSearchLeads = true, // eslint-disable-line @typescript-eslint/no-unused-vars
    onKeyEnter = false,
    onFiltersUpdated,
    baseFilters,
  }: {
    filterKey: string;
    filterValue: any;
    filterType: string;
    filterExcludeKey?: string;
    showExactMatch?: boolean;
    showKnownUnknown?: number;
    showIncludePastJobs?: boolean;
    isSearchLeads?: boolean;
    onKeyEnter?: boolean;
    onFiltersUpdated?: (updatedFilters: URLSearchParams) => void;
    baseFilters?: URLSearchParams;
  }) => {
    const startingFilters = baseFilters || pendingFilters;

    // Update pending filters - function returns a new object (immutable)
    const newPendingFilters = updatePendingFilters(
      startingFilters,
      filterKey,
      filterValue,
      filterType,
      filterExcludeKey,
      showExactMatch,
      showKnownUnknown,
      showIncludePastJobs,
    );

    // Update pending filters state
    setPendingFilters(newPendingFilters);

    // Callback with updated filters (useful for immediate application)
    if (onFiltersUpdated) {
      onFiltersUpdated(newPendingFilters);
    }

    // Only update URL immediately if Enter key was pressed (for keyword search)
    if (onKeyEnter) {
      isSearchButtonClickRef.current = true;
      const queryString = newPendingFilters.toString();
      const shouldSkipPush = skipUrlPushForBulkSearch;

      if (!shouldSkipPush) {
        history.push({
          search: queryString,
        });
      } else if (triggerSearchWithFilters) {
        const filtersStr = newPendingFilters.toString();
        if (filtersStr !== lastAppliedFiltersRef.current) {
          lastAppliedFiltersRef.current = filtersStr;
          triggerSearchWithFilters(newPendingFilters);
        }
      }
    }
    // Otherwise, filters are stored in pendingFilters and will be applied when search button is clicked
  };

  const handleBulkQuery = (
    bulkQueryInputs: {
      filterKey: string;
      filterValue: any;
      filterType: string;
      filterExcludeKey?: string;
      showExactMatch?: boolean;
      showKnownUnknown?: number;
      showIncludePastJobs?: boolean;
    }[],
    onFiltersUpdated?: (updatedFilters: URLSearchParams) => void,
    options?: { baseFilters?: URLSearchParams },
  ) => {
    // Start with current pending filters and apply each update sequentially
    // Each updatePendingFilters call returns a new object (immutable)
    let newPendingFilters = options?.baseFilters || pendingFilters;

    bulkQueryInputs.forEach(
      ({
        filterKey,
        filterValue,
        filterType,
        filterExcludeKey,
        showExactMatch,
        showKnownUnknown,
        showIncludePastJobs,
      }) => {
        newPendingFilters = updatePendingFilters(
          newPendingFilters,
          filterKey,
          filterValue,
          filterType,
          filterExcludeKey,
          showExactMatch,
          showKnownUnknown,
          showIncludePastJobs,
        );
      },
    );

    // Update pending filters state
    setPendingFilters(newPendingFilters);

    // Callback with updated filters (useful for immediate application)
    if (onFiltersUpdated) {
      onFiltersUpdated(newPendingFilters);
    }
    // Otherwise, filters are stored in pendingFilters and will be applied when search button is clicked
  };

  // Apply pending filters to URL and trigger search
  // Optionally accepts filters to apply (useful when state hasn't updated yet)
  const applyPendingFilters = (
    filtersToApply?: URLSearchParams,
    options?: { skipUrlPush?: boolean },
  ) => {
    isSearchButtonClickRef.current = true;
    const filters = filtersToApply || pendingFilters;
    const queryString = filters.toString();
    const shouldSkipPush =
      options?.skipUrlPush === true || skipUrlPushForBulkSearch;

    if (!shouldSkipPush) {
      history.push({
        search: queryString,
      });
    } else if (triggerSearchWithFilters) {
      const filtersStr = filters.toString();
      if (filtersStr === lastAppliedFiltersRef.current) {
        return;
      }
      lastAppliedFiltersRef.current = filtersStr;
      triggerSearchWithFilters(filters);
    }
  };

  // Check if there are any pending filters (excluding pagination params)
  const hasPendingFilters = () => {
    // Use toString() to ensure proper copying of URLSearchParams object
    const params = new URLSearchParams(pendingFilters.toString());
    // Remove pagination params
    params.delete('page');
    params.delete('start');
    params.delete('take');
    return params.toString().length > 0;
  };

  // Sync pending filters with current URL (for initial load or external URL changes)
  const syncPendingFiltersWithUrl = () => {
    setPendingFilters(new URLSearchParams(location?.search));
  };

  // Clear all pending filters
  const clearPendingFilters = () => {
    setSkipUrlPushForBulkSearch(false);
    setPendingFilters(new URLSearchParams());
    lastAppliedFiltersRef.current = '';
    syncPeopleFiltersTabRef(new URLSearchParams());
  };

  const handleDeleteFilter = (filter, applyFilters = false) => {
    if (!filter) return false; // Return false if no filter provided

    // Use toString() to ensure proper copying of URLSearchParams object
    const newPendingFilters = new URLSearchParams(pendingFilters.toString());
    filter?.type.forEach((type) => {
      newPendingFilters.delete(type?.key);
      // Delete associated flags
      newPendingFilters.delete(`${type?.key}_exactMatch`);
      newPendingFilters.delete(`${type?.key}_isUnknown`);
      newPendingFilters.delete(`${type?.key}_shouldSearchPast`);
      // Delete exclude key with capitalized format
      if (type?.key) {
        newPendingFilters.delete(
          `exclude${type.key.charAt(0).toUpperCase()}${type.key.slice(1)}`,
        );
      }

      // If user clears the Company filter (`company_ids`), also clear bulk-search company name params.
      if (type?.key === 'company_ids') {
        newPendingFilters.delete('company_name');
        newPendingFilters.delete('excludeCompany_name');
        newPendingFilters.delete('company_name_exactMatch');
        newPendingFilters.delete('company_name_shouldSearchPast');
      }
    });

    setPendingFilters(newPendingFilters);
    syncPeopleFiltersTabRef(newPendingFilters);

    // If applyFilters is true, check if we should trigger search or clear all
    if (applyFilters) {
      // Check if there are any remaining filters (excluding pagination)
      // Use toString() to ensure proper copying of URLSearchParams object
      const remainingFilters = new URLSearchParams(
        newPendingFilters.toString(),
      );
      remainingFilters.delete('page');
      remainingFilters.delete('start');
      remainingFilters.delete('take');

      // If no remaining filters, return true to indicate clear all
      if (remainingFilters.toString().length === 0) {
        return true; // Signal that clear all should be called
      }

      // Apply the remaining filters and trigger search API
      applyPendingFilters(newPendingFilters);
      return false; // No clear all needed
    }

    // Don't update URL immediately - wait for search button
    return false;
  };

  const applyExternalBulkFilters = (filters: URLSearchParams) => {
    setSkipUrlPushForBulkSearch(true);
    setPendingFilters(new URLSearchParams(filters.toString()));
    if (triggerSearchWithFilters) {
      lastAppliedFiltersRef.current = filters.toString();
      triggerSearchWithFilters(filters);
    }
  };

  useEffect(() => {
    if (!bulkPeopleSearch.isPending) return;
    if (activeLeadType !== LeadFinderPrimaryTab.PEOPLE) return;
    const filters = new URLSearchParams(bulkPeopleSearch.filters);
    dispatch(clearBulkPeopleSearch());
    dispatch(setBulkPeopleModeActive(true));
    applyExternalBulkFilters(filters);
  }, [bulkPeopleSearch.isPending, activeLeadType]);

  useEffect(() => {
    const switchedToPeopleTab =
      prevActiveLeadTypeRef.current !== LeadFinderPrimaryTab.PEOPLE &&
      activeLeadType === LeadFinderPrimaryTab.PEOPLE;

    if (!switchedToPeopleTab) return;
    if (!skipUrlPushForBulkSearch) return;
    if (!triggerSearchWithFilters) return;
    const urlIsEmpty = (location?.search || '').trim().length === 0;
    if (!urlIsEmpty) return;

    const filtersStr = pendingFilters.toString();
    if (!filtersStr) return;

    const filters = new URLSearchParams(filtersStr);
    lastAppliedFiltersRef.current = filtersStr;
    triggerSearchWithFilters(filters);
  }, [
    activeLeadType,
    skipUrlPushForBulkSearch,
    triggerSearchWithFilters,
    location?.search,
    pendingFilters,
  ]);

  useEffect(() => {
    prevActiveLeadTypeRef.current = activeLeadType;
  }, [activeLeadType]);

  return {
    handleQuery,
    handleDeleteFilter,
    handleGetAllKeysByFilterFromQuery,
    handleIndividualTag,
    handleFoundValueExceptFromList,
    handleBulkQuery,
    applyPendingFilters,
    applyExternalBulkFilters,
    hasPendingFilters,
    syncPendingFiltersWithUrl,
    clearPendingFilters,
    pendingFilters,
    isSearchButtonClickRef,
    companyIdNameMap,
    setCompanyIdNameMap,
    skipUrlPushForBulkSearch,
    setSkipUrlPushForBulkSearch,
  };
};
